/**************************************************
 * Nombre:       Formulario_Lead_Datos.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    ApartmentOutlined,
    Mail,
    BadgeOutlined,
    SmartphoneOutlined,
    WhatsApp
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSPEDIDOS} from "../../Constantes";
import IngresoTextoLista from "../../Modulo_formularios/Componentes/IngresoTextoLista";
import IngresoSelectFalsoVerdadero from "../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";
import IngresoTextoBoton from "../../Modulo_formularios/Componentes/IngresoTextoBoton";
import {iniciarChatWass} from "../../Modulo_ChatWass/Funciones/iniciarChatWass";
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";
import IngresoImagenCropCustom from "../../Modulo_formularios/Componentes/IngresoImagenCropCustom";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Lead_Datos = ({...props}) => {

    const chatWhatsApp = (num) => {

        iniciarChatWass({numero: props.props.getValues("celular"), pais: props.props.getValues("pais"), local: false});

    }

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >



                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop  dato={'img'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'} dato={'nombres'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num id'} dato={'cc'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTextoBoton Icono={SmartphoneOutlined} nombre={'Celular'} dato={'celular'} {...props}
                                       click={chatWhatsApp} IconoFinal={WhatsApp}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={ApartmentOutlined} nombre={'Ciudad'} dato={'ciudad'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Mail} nombre={'Correo'} dato={'correo'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Lead_Datos